const maxWidth = 700;

export { maxWidth };